document.addEventListener("DOMContentLoaded", function () {
  const planRadios = document.querySelectorAll(
    'input[name="selling_plan_option"]'
  );
  const purchaseRadios = document.querySelectorAll(
    'input[name="purchase_option"]'
  );
  const sellingPlanInput = document.querySelector('input[name="selling_plan"]');

  function updatePlan(value) {
    const subscriptionInput = document.querySelector(
      'input[value="subscription"]'
    );
    const picker = document.querySelector("skio-plan-picker");

    if (!picker || !picker.shadowRoot) return;
    subscriptionInput.checked = true;
    const inputs = picker.shadowRoot.querySelectorAll("input.group-input");
    inputs.forEach((input) => {
      const inputValue = input.value.toLowerCase();
      if (inputValue !== "one time purchase") {
        input.click();
      }
    });

    const subscriptionDropDown = picker.shadowRoot.querySelector(
      ".selling-plan-dropdown"
    );
    if (!subscriptionDropDown) return;

    subscriptionDropDown.value = value;
    subscriptionDropDown.dispatchEvent(new Event("change", { bubbles: true }));
  }

  purchaseRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      const isSub = radio.value === "subscription";
      const picker = document.querySelector("skio-plan-picker");
      if (!picker || !picker.shadowRoot) return;

      const inputs = picker.shadowRoot.querySelectorAll("input.group-input");
      inputs.forEach((input) => {
        const inputValue = input.value.toLowerCase();
        if (isSub) {
          if (inputValue !== "one time purchase") {
            input.click();
          }
        } else {
          if (inputValue === "one time purchase") {
            input.click();
          }
        }
      });
    });
  });

  planRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      updatePlan(radio.value);
    });
  });
});